import React from "react";
import classnames from "classnames";

const LiSingleTreeElement = ({
  route,
  menuName,
  menuIcon,
  activeSideBar,
  toggle,
}) => {
  return (
    <li
      className={classnames({
        active: activeSideBar === route,
      })}
    >
      <a
        href={route}
        onClick={() => {
          toggle(route);
        }}
      >
        <i className={menuIcon}></i>
        <span>{menuName}</span>
      </a>
    </li>
  );
};

export default LiSingleTreeElement;
